<div class="outer">
  <h1>Money</h1>
  <p>View your earnings from sales and subscriptions, and manage payouts.</p>

  <div *ngIf="isLoading" class="loading-container">
    <p>Loading financial data...</p>
    <!-- You could add a spinner component here -->
  </div>

  <div *ngIf="!isLoading && currentUser">
    <!-- Summary Cards -->
    <div class="summary-cards">
      <div class="card">
        <h3>Total Earnings (All Time)</h3>
        <p class="amount">{{ totalEarnings | currency }}</p>
      </div>
      <div class="card">
        <h3>Available for Payout</h3>
        <p class="amount">{{ pendingPayout | currency }}</p>
      </div>
      <div class="card">
        <h3>Last Payout Date</h3>
        <p>{{ lastPayoutDate ? (lastPayoutDate | date) : "N/A" }}</p>
      </div>
    </div>

    <!-- Payout Request Section -->
    <div class="payout-section">
      <h2>Request Payout</h2>
      <div *ngIf="hasPendingPayouts">
        <p class="success-message">
          You have a payout request that is currently being processed.
        </p>
      </div>
      <div *ngIf="!hasPendingPayouts">
        <p>
          When you're ready, you can request a payout of your available balance.
          A minimum of $50 is required.
        </p>

        <div class="payout-details">
          <p>
            Available Balance: <strong>{{ pendingPayout | currency }}</strong>
          </p>
          <p>
            Your Payout Rate ({{ currentUser.creatorType | titlecase }} Tier):
            <strong>{{ payoutPercentage }}%</strong>
          </p>
          <p>
            Estimated Payout:
            <strong class="net-payout-amount">{{
              netPayout | currency
            }}</strong>
          </p>
        </div>

        <button
          (click)="requestPayout()"
          [disabled]="!canRequestPayout || payoutRequesting"
          class="payout-button"
        >
          <span *ngIf="!payoutRequesting">Request Payout</span>
          <span *ngIf="payoutRequesting">Requesting...</span>
        </button>
        <p
          *ngIf="!canRequestPayout && !hasPendingPayouts && pendingPayout > 0"
          class="info-message"
        >
          You need at least $50.00 to request a payout.
        </p>
      </div>
    </div>

    <!-- Transactions Table -->
    <div class="transactions-section">
      <h2>Transaction History</h2>
      <div
        *ngIf="transactions.length > 0; else noTransactions"
        class="table-container"
      >
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Description</th>
              <th>Status</th>
              <th class="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of transactions">
              <td>{{ tx.date | date : "mediumDate" }}</td>
              <td>
                <span class="tag" [ngClass]="tx.type.toLowerCase()">{{
                  tx.type
                }}</span>
              </td>
              <td>{{ tx.description }}</td>
              <td>
                <span
                  class="tag status-tag"
                  [ngClass]="'status-' + tx.status"
                  >{{ tx.status }}</span
                >
              </td>
              <td class="text-right amount-positive">
                {{ tx.amount | currency }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noTransactions>
        <p class="no-data-message">You have no transactions yet.</p>
      </ng-template>
    </div>
  </div>
</div>
